import { render } from "./AssistantFloatingButton.vue?vue&type=template&id=91d1fc16&scoped=true"
import script from "./AssistantFloatingButton.vue?vue&type=script&lang=js"
export * from "./AssistantFloatingButton.vue?vue&type=script&lang=js"

import "./AssistantFloatingButton.vue?vue&type=style&index=0&id=91d1fc16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d1fc16"]])

export default __exports__